// API Configuration for OpenRouter (via Cloudflare Worker)

// Worker URLs
const WORKER_URLS = {
    production: 'https://thiet-chuan-api.sociads.workers.dev',
    development: 'https://thiet-chuan-api.sociads.workers.dev', // Also use production for dev (no local worker)
};

// Get the appropriate Worker URL
export function getWorkerUrl() {
    // First check if explicitly set in localStorage (for testing)
    const customUrl = localStorage.getItem('worker_url');
    if (customUrl) return customUrl;

    // Always use production URL (worker is deployed on Cloudflare)
    return WORKER_URLS.production;
}

// Get stored app password
export function getAppPassword() {
    return localStorage.getItem('app_password') || '';
}

// Set app password
export function setAppPassword(password) {
    localStorage.setItem('app_password', password);
}

// Clear authentication
export function clearAuth() {
    localStorage.removeItem('app_password');
}

// Check if authenticated
export function isAuthenticated() {
    return !!localStorage.getItem('app_password');
}

export const API_CONFIG = {
    // Worker endpoint for API calls
    WORKER_API_ENDPOINT: '/api/analyze',
    // Default model
    DEFAULT_MODEL: 'google/gemini-3-flash-preview',
    MODELS: {
        'gemini-flash': 'google/gemini-3-flash-preview',
        'gemini-pro': 'google/gemini-3-pro-preview',
        'claude-sonnet': 'anthropic/claude-sonnet-4.5',
    },
    TIMEOUT: 60000, // 60 seconds
    MAX_IMAGE_SIZE: 1024 * 1024, // 1MB
};

export const MODEL_LIST = [
    { id: 'google/gemini-3-flash-preview', name: 'Gemini 3 Flash Preview', desc: 'Mặc định - Nhanh & Tốt' },
    { id: 'google/gemini-3-pro-preview', name: 'Gemini 3 Pro Preview', desc: 'Thông minh nhất' },
    { id: 'openai/gpt-5.2', name: 'GPT-5.2', desc: 'Mạnh mẽ & Đắt' },
    { id: 'openai/gpt-5-mini', name: 'GPT-5 Mini', desc: 'Nhanh gọn' },
    { id: 'anthropic/claude-sonnet-4.5', name: 'Claude Sonnet 4.5', desc: 'Code & Logic tốt' },
    { id: 'anthropic/claude-haiku-4.5', name: 'Claude Haiku 4.5', desc: 'Siêu tốc độ' },
    { id: 'qwen/qwen3-vl-235b-a22b-thinking', name: 'Qwen 3 VL Thinking', desc: 'Vision mạnh mẽ' },
    { id: 'z-ai/glm-4.7', name: 'GLM 4.7', desc: 'Cân bằng' },
    { id: 'bytedance-seed/seedream-4.5', name: 'Seedream 4.5', desc: 'Mới & Lạ' },
];
